import React, { useState } from 'react';
import { Card, Form, Col, Row, Button } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import Confirmation from '../ui/Confirmation';
import { AiFillDelete } from 'react-icons/ai';
const baseUrl = process.env.REACT_APP_API;

const CardBanner = ({ bn, callBk }) => {
    const [link, setLink] = useState(bn.link);
    const { setResp } = useContextInfo();
    const [showd, setShowd] = useState(false);
    const info = { id: bn.id, type: 'BANNER' };

    const onSubmit = async (e) => {
        e.preventDefault();
        const resp = await fetchConToken('main/banner', { id: bn.id, link }, 'POST');
        setResp(resp);
        callBk();
    };
    return (
        <Card>
            <Card.Body className="d-block">
                <Card.Title className="d-flex justify-content-between">
                    <span> Banner </span>{' '}
                    <AiFillDelete
                        className="fs-4 icon-link icon-link-hover link-danger link-underline-danger link-underline-opacity-75"
                        onClick={() => setShowd(true)}
                    />
                </Card.Title>
            </Card.Body>
            <Card.Img src={`${baseUrl}${bn.foto}`} className="img-fluid" />
            <Form noValidate onSubmit={onSubmit}>
                <Card.Body>
                    <Col>
                        {' '}
                        <Form.Group className="mb-2">
                            <Form.Label>Link </Form.Label>
                            <Form.Control type="text" value={link} onChange={(e) => setLink(e.target.value)} />{' '}
                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                        </Form.Group>{' '}
                    </Col>
                    <Button type="submit">Guardar cambios</Button>
                </Card.Body>
            </Form>
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={callBk} />
        </Card>
    );
};

export default CardBanner;
